var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacing = void 0;
var Spacing_1 = __importDefault(require("./Spacing"));
exports.Spacing = Spacing_1.default;
exports.default = Spacing_1.default;
//# sourceMappingURL=index.js.map